import TableTemplate, {
  IFilterTableCols,
} from "../../TableTemplate/tableTemplate";
import {
  IOptionDomainPortfoWatchListSearchParam,
  IOptionDomainSearchParams,
} from "../../../Interfaces/optionDomain";
import { CommonTableUI } from "../../TableTemplate/common";
import { getLiveWatchlistTable } from "../../../Requests/optionDomain";

interface IProps {
  filterCols: IFilterTableCols;
  searchParams: IOptionDomainSearchParams;
  refreshFlag: boolean;
}

const OptionCalculationTable = ({
  filterCols,
  searchParams,
  refreshFlag,
}: IProps) => {
  return (
    <TableTemplate<IOptionDomainPortfoWatchListSearchParam, any>
      TableUI={({ reports, onAction }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          filterCols={filterCols}
          tableBoxClassName="!max-h-[600]"
          refreshFlag={refreshFlag}
        />
      )}
      getDataTable={getLiveWatchlistTable}
      searchParameters={searchParams}
    />
  );
};

export default OptionCalculationTable;
